import Vue from 'vue';
import VueRouter from 'vue-router';
import AuthLayout from "@/views/Layout/AuthLayout";
import DashboardLayout from "@/views/Layout/DashboardLayout";
import authGuard from "@/routes/authGuard";

Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: "history",
  routes: [
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      meta: {
        requiresAuth: false,
      },
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('../views/Login.vue')
        },
      ]
    },
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      meta: {
        requiresAuth: true,
        roles: ['administrator']
      },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/Dashboard.vue')
        },
        {
          path: '/user-create',
          name: 'user-create',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/users/Create.vue')
        },
        {
          path: '/user-list',
          name: 'user-list',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/users/Index.vue')
        },
        {
          path: '/tarjeta-go-list',
          name: 'tarjeta-go',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/go-card/GoCard')
        },
        {
          path: '/user-view/:id',
          name: 'user-view',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/users/Detail.vue')
        },
        {
          path: '/notifications-create',
          name: 'notifications-create',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/notifications/Create.vue')
        },
        {
          path: '/notifications',
          name: 'notifications',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/notifications/index.vue')
        },
        {
          path: 'faqs',
          name: 'faqs',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/faqs/Faqs.vue')
        },{
          path: 'news',
          name: 'news',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/news/News.vue')
        },
        {
          path: 'support',
          name: 'support',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/support/Support.vue')
        },
        {
          path: 'support-detail',
          name: 'support-detail',
          meta: {
            requiresAuth: true,
            roles: ['administrator']
          },
          component: () => import( '../views/Dashboard/support/Detail.vue')
        },
      ]
    },
    {
      path: "*",
      component: () => import("@/views/NotFoundPage"),
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {selector: to.hash};
    }
    return {x: 0, y: 0};
  }
});
router.beforeEach(authGuard);
export default router;
